<script setup>
import { inject } from 'vue';

defineProps({
    value: {
        type: String,
        required: true,
    },
    as: {
        type: String,
        default: 'button',
    },
    openViewOnClick: {
        type: Boolean,
        default: false,
    },
});

const search = inject('app-search', null);

if (!search) {
    throw new Error('app-search-bar-icon must be used within an app-search component');
}
</script>

<template>
    <component
        :is="as"
        :type="as === 'button' ? 'button' : undefined"
        class="flex items-center justify-center rounded-full"
        @click="openViewOnClick ? search.openView() : undefined"
    >
        <component :is="`icon-${value}`" class="size-6" />
    </component>
</template>
